<template>
  <Teleport to="body">
    <Drawer :title="`Edit Details — Quote #${quote.id}`" @hide-drawer="onHide">
      <QuoteDetails ref="detailsRef" :quote="quote" />
      <template #footer>
        <div class="flex gap-3 w-full">
          <Button
            label="Cancel"
            type="Secondary"
            class="flex-1"
            @click="close"
          />
          <Button
            label="Save"
            type="Primary"
            class="flex-1"
            :disabled="saving"
            @click="onSave"
          />
        </div>
      </template>
    </Drawer>
  </Teleport>
</template>

<script lang="ts" setup>
import { ref } from "vue";

import Button from "@/components/Seranova/Buttons/Button.vue";
import Drawer from "@/components/Seranova/Drawer/Drawer.vue";
import type { Quote } from "@/typings/quote";
import QuoteDetails from "./QuoteDetails.vue";

defineProps<{
  quote: Quote;
}>();

const emit = defineEmits<{
  "hide-drawer": [];
}>();

const detailsRef = ref<InstanceType<typeof QuoteDetails> | null>(null);
const saving = ref(false);

const close = () => {
  emit("hide-drawer");
};

const onHide = () => {
  emit("hide-drawer");
};

const onSave = async () => {
  saving.value = true;
  try {
    await detailsRef.value?.save();
    window.notify.success("Quote details updated successfully");
    close();
  } catch {
    window.notify.error("Failed to update quote details");
  } finally {
    saving.value = false;
  }
};
</script>
